import { TOGGLE_AROUND_ME_MODE } from "./aroundMeModeReducer"

export const toggleAroundMeMode = (value) => ({
    type: TOGGLE_AROUND_ME_MODE,
    payload: value
})